import { on } from '@ngrx/store'
import { State } from '../channels.state'
import {
  GetHopperStatusSuccess,
  ConnectHopperSuccess,
  GetHopperRentalValidationsSuccess,
  CreateHopperListingSuccess,
  UpdateHopperListingSuccess,
  ActivateHopperListingSuccess,
  DeactivateHopperListingSuccess,
  DeleteHopperListingSuccess,
  GetHopperListingsSuccess,
  DisconnectHopperSuccess,
} from './actions'
import { HopperListingModel } from './model'

export function getHopperReducers() {
  return [
    on(GetHopperStatusSuccess, (state: State, { status }) => ({
      ...state,
      hopper: {
        ...state.hopper,
        status,
      },
    })),
    on(ConnectHopperSuccess, (state: State) => ({
      ...state,
      hopper: {
        ...state.hopper,
        status: { connected: true },
      },
    })),
    on(GetHopperRentalValidationsSuccess, (state: State, { validations }) => ({
      ...state,
      hopper: {
        ...state.hopper,
        validations,
        validationsLoaded: true,
      },
    })),
    on(CreateHopperListingSuccess, UpdateHopperListingSuccess, (state: State, { listing }) => ({
      ...state,
      hopper: {
        ...state.hopper,
        listings: state.hopper.listings.map((l) =>
          l._id === listing.rentalId ? { ...l, ...listing, active: true } : l
        ),
      },
    })),
    on(ActivateHopperListingSuccess, DeactivateHopperListingSuccess, (state: State, { rentalId, active }) => ({
      ...state,
      hopper: {
        ...state.hopper,
        listings: state.hopper.listings.map((l) => (l._id === rentalId ? { ...l, active: active } : l)),
      },
    })),
    on(DeleteHopperListingSuccess, (state: State, { rentalId }) => ({
      ...state,
      hopper: {
        ...state.hopper,
        listings: state.hopper.listings.map((l) =>
          l._id === rentalId
            ? ({
                ...l,
                active: false,
                lastSync: null,
              } as HopperListingModel)
            : l
        ),
      },
    })),
    on(GetHopperListingsSuccess, (state: State, { listings }) => ({
      ...state,
      hopper: {
        ...state.hopper,
        listings,
      },
    })),
    on(DisconnectHopperSuccess, (state: State) => {
      return {
        ...state,
        hopper: {
          ...state.hopper,
          status: { connected: true },
        },
      }
    }),
  ]
}
